import { Box } from "../Box/Box";
import { List } from "../Container/List/List";
import { MenuItem } from "./MenuItem";
import { CFlexContainer } from "../Container/CFlexContainer";
import { getAppService, toMap } from "../../../../HA";

export class MenuPane extends Box {
    public clear(): this {
        this.getItems().clear();
        return this;
    }

    public addItem(data: Map<string, any>): void {
        data.set("click", () => {
            this.handleClick(data);
        });
        this.getItems().addItem(new MenuItem(data));
    }

    public handleClick(data: any) {
        const a = data.get("a");
        const service = getAppService();
        if (a instanceof Map || a instanceof Array) {
            service.processAction(toMap(a as any) as Map<any, any>);
            return;
        }
        service.processAction(toMap({id: data.get("id"), t: "reloadApp"}) as Map<any, any>);
    }

    protected createSelf(): void {
        super.createSelf();
        this.addClass("menupane");
        const items = new List({tag: new CFlexContainer({class: "menus"})});
        this.appendChild(items);
        this.addToData("items", items);
    }

    protected createItems(): void {
        const items: Map<any, any> = this.get("i");
        if (items) {
            items.forEach((i) => {
                this.addItem(toMap(i) as Map<string, any>);
            });
        }
    }

    protected initialize(data: any): void {
        super.initialize(data);
        this.createItems();
    }

    private getItems(): List {
        return this.get("items");
    }
}
